// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { fetchProjectCompanies } from 'helpers/api'
import { updateCompanies } from 'redux/modules/projectSummary'

const fetchAndSetProjectCompanies = projectId => async dispatch => {
  const { entities } = await fetchProjectCompanies(projectId)
  dispatch(updateCompanies(entities))
}

export default fetchAndSetProjectCompanies
